<div *ngIf="router.url === '/contratista/docpropia'">
 
  <app-nav-bar-contratista></app-nav-bar-contratista>
</div>

<div *ngIf="router.url === '/contratista/estado/instalaciones'">
 
  <app-nav-bar-contratista></app-nav-bar-contratista>
</div>

<div *ngIf="router.url === '/contratista/estado/clientes'">
   
  <app-nav-bar-contratista></app-nav-bar-contratista>
</div>
<div *ngIf="router.url === '/contratista/estado/centros'">
  
  <app-nav-bar-contratista></app-nav-bar-contratista>
</div>
<div *ngIf="router.url === '/contratista/estado/gestores'">
 
  <app-nav-bar-contratista></app-nav-bar-contratista>
</div>
<div *ngIf="router.url === '/contratista/estado/transportistas'">
 
  <app-nav-bar-contratista></app-nav-bar-contratista>
</div>
<div *ngIf="router.url === '/contratista/estado'">
  <h1>Entidad / Estado</h1>
</div>
<div *ngIf="router.url === '/contratista/perfil'">
  <h1>Perfil de Empresa</h1>
</div>
<div *ngIf="router.url === '/contratista/docpropia'">
 
</div>
